import { render, staticRenderFns } from "./EditServiceSideBarTabs.vue?vue&type=template&id=481d8736&"
import script from "./EditServiceSideBarTabs.vue?vue&type=script&lang=js&"
export * from "./EditServiceSideBarTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports